import { render, staticRenderFns } from "./ListagemCoSeller.vue?vue&type=template&id=4bc88495&scoped=true&"
import script from "./ListagemCoSeller.vue?vue&type=script&lang=js&"
export * from "./ListagemCoSeller.vue?vue&type=script&lang=js&"
import style0 from "./ListagemCoSeller.vue?vue&type=style&index=0&id=4bc88495&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc88495",
  null
  
)

export default component.exports